import * as React from 'react'
import { Separator as SeparatorPrimitive } from '@base-ui/react/separator'

import { cn } from '@/registry/reapit/lib/utils'

// ---------------------------------------------------------------------------
// Separator — migrated from Radix to Base UI
// ---------------------------------------------------------------------------
// Base UI's Separator always renders role="separator". Radix had a `decorative`
// prop that rendered role="none" when true. We preserve that public API by
// overriding the role when decorative is true.
// ---------------------------------------------------------------------------

export namespace Separator {
  export interface Props extends Omit<React.ComponentProps<typeof SeparatorPrimitive>, 'role'> {
    /**
     * When true the separator is purely visual and announced as role="none".
     * @default true
     */
    decorative?: boolean
  }
}

function Separator({ className, orientation = 'horizontal', decorative = true, ...props }: Separator.Props) {
  return (
    // DS: separator uses --border (neutral-100, #E5E9ED) — bg-border already maps to this token
    <SeparatorPrimitive
      data-slot="separator"
      role={decorative ? 'none' : 'separator'}
      aria-orientation={!decorative && orientation === 'vertical' ? 'vertical' : undefined}
      orientation={orientation}
      className={cn(
        'shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className,
      )}
      {...props}
    />
  )
}

export { Separator }
